module.exports = __webpack_public_path__ + "img/fogg-order-completed.cfb75900.svg";